var styles = {"light":"styles_light__1WCxS","dark":"styles_dark__1zpyI","inherit":"styles_inherit__Mh8H2"};

export default styles;
//# sourceMappingURL=styles.css.js.map
